import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="font-display font-bold tracking-[0.2em] uppercase text-sm inline-block text-center">
            <span className="block">JordyBT<span className="gold-text">_Fitness</span></span>
            <span className="block text-[10px] tracking-[0.3em] text-white/40 mt-1">Elite Coaching</span>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50">
            <Link data-testid="footer-privacidad" to="/privacidad" className="hover:text-[#D4AF37] transition-colors">
              Política de privacidad
            </Link>
            <Link data-testid="footer-cookies" to="/cookies" className="hover:text-[#D4AF37] transition-colors">
              Política de cookies
            </Link>
            <Link data-testid="footer-aviso" to="/aviso-legal" className="hover:text-[#D4AF37] transition-colors">
              Aviso legal
            </Link>
            <Link data-testid="footer-admin" to="/admin/login" className="hover:text-[#D4AF37] transition-colors">
              Acceso
            </Link>
          </nav>
        </div>
        <div className="gold-divider my-8" />
        <p className="text-center text-[11px] text-white/30">
          © {new Date().getFullYear()} JordyBT_Fitness — Elite Coaching. Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
